import { Arg, Entity, Field, Mutation } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class IntentInfo extends AdornisEntity {
  static override _class = 'IntentInfo';

  @validate(nonOptional())
  @Field(type => String)
  clientSecret!: string;

  @validate(nonOptional())
  @Field(type => String)
  paymentID!: string;
}

@Entity()
export class Intent extends AdornisEntity {
  static override _class = 'Intent';

  @Mutation(type => Boolean)
  static validatedIntent(@Arg('paymentIntentID', type => String) paymentIntentID: string) {
    return async () => {};
  }
}
